import GridConfig from "core/grid/domain/gridConfig";
import {observable} from "mobx";
import {DomainAncestor, entityConfig, fieldInfo} from "core/common/domain/DomainAncestor";
import MdField, {FIELDTYPE} from "core/metamodel/mdField";
import {GridLocationField} from "core/grid/domain/grid";
import {Document} from "core/document/documentDomain";


@entityConfig()
export default class GridConfigColumn extends DomainAncestor {

  // zpetna reference na parenta
  public $gridConfigRef: GridConfig;

  @observable public field: MdField;

  @observable public sum: boolean;

  @observable public avg: boolean;

  @observable public $selected: boolean;


  constructor (gridConfig: GridConfig, json: any) {
    super(json);
    this.$gridConfigRef = gridConfig;
    if (this.field) this.field = (gridConfig && this.field.fieldType !== FIELDTYPE.SQLRESULT) ? gridConfig.getEntityRef().getField(this.field.fieldName) : new MdField(this.field);
  }


  get label() {
    return this.field.label;
  }

  get gridHeaderLabelActive(): string {
    if (this.field) {
      let gridLocationField: GridLocationField = this.$gridConfigRef.$gridLocationRef.fields.get(this.field.fieldName);
      let headerLabelActive = (gridLocationField) ? gridLocationField.gridHeaderLabel : null;
      return (headerLabelActive != null) ? headerLabelActive : this.field.gridHeaderLabelActive;
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// ./src/core/grid/domain/gridConfigColumn.ts